import React from 'react'
import PropTypes from 'prop-types'
import ExpandMore from '@mui/icons-material/ExpandMore'

const ExpandMoreIcon = ({ height, width, ...more }) => {
	
	return (
		<ExpandMore
			height={height}
			width={width}
			{...more}
		/>
	)
}

ExpandMoreIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default ExpandMoreIcon
